/**
 * $.ajax request width $.fn.serialize() for all, valid, inputs
 * @example
	$('#form').on('submit', function(ev) {
		ev.preventDefault();
		var extraData = '&dataNotInSerialize=12345';

		$_GP.ajaxSubmitInner('#form', {
			url: 'url/to/endpoint',
			data: extraData,
			formReset: false,
			done: function(resp) {
				// request succeded and resp.success === true
			},
			$ajax: function($elm, request) {
				// $elm = $('#form')
				// request = $.ajax request
			}
		});

		return false;
	});
 * @param {string|jQuery} elm - form element
 * @param {object} opt - options
 * @property {string} opt.url - endpoint, $.ajax url
 * @property {string|object} [opt.data] - extradata to ben send in $.ajax data
 * @property {string} [opt.dataType='json'] - $.ajax dataType
 * @property {string} [opt.type='POST'] - $.ajax type
 * @property {boolean} [opt.formReset=true] - reset form in done and !!resp.success
 * @property {string} [opt.submitFailMsm=$_GP.msm.submitFail] - fail msm
 * @property {function} [opt.done(resp)] - callback in request done and resp.success is truthy
 *   @param {*} resp - depends in $.ajax response
 * @property {function} [opt.$ajax($elm, request)] - callback
 *   @param {jQuery} $elm - form element
 *   @param {object} request - $.ajax request
 * @returns {object} $.ajax request
 * @requires $_GP.ajax,$_GP.msm.submitFail
 */
$_GP.ajaxSubmitInner = function(elm, opt) {
	const $elm = $(elm);
	const serializeWithoutToken = $elm.find('input[name!="csrfTokenGP"], textarea, select').serialize();

	let data;
	if ($_GP._.is('string', opt.data)) {
		data = serializeWithoutToken + opt.data;
	} else if ($_GP._.is('object', opt.data)) {
		data = serializeWithoutToken + '&' + $.param(opt.data);
	} else {
		data = serializeWithoutToken;
	}

	const request = $_GP.ajax( opt.url, data, opt.dataType, opt.type);

	const formReset = opt.formReset === false ? false : true;

	$elm.find('button[type="submit"]').prop('disabled', true)
		.find('.fa-sync').removeClass('hide');

	request.done(function(resp) {
		if (!resp.success) {
			spop({ template: resp.info, style: 'error', group: elm});
			return;
		}

		spop({ template: resp.info, style: 'success', group: elm, autoclose: 5000 });

		if (formReset) $elm[0].reset();

		if (opt.done) opt.done(resp);

	}).fail(function() {
		spop({template: (opt.submitFailMsm ? opt.submitFailMsm : $_GP.msm.submitFail), style: 'error', group: elm });
	}).always(function() {
		$elm.find('button[type="submit"]').prop('disabled', false)
			.find('.fa-sync').addClass('hide');
	});

	if (opt.$ajax) opt.$ajax($elm, request);

	return request;
};
